// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class LockArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.LockArgs';
  $t: string = 'SagaBase.Defines.LockArgs';

  public static GetMembers(): string[] {
    return ['ObjGuid', 'LockHandle', 'Locking', 'ClassName', 'LockResult'];
  }

  public GetMembers(): string[] {
    return LockArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ObjGuid: Guid = GuidTools.Empty;
  public LockHandle: Guid = GuidTools.Empty;
  public Locking: SagaBase.Interfaces.Locking = SagaBase.Interfaces.Locking.Lock;
  public ClassName: string;
  public LockResult: SagaBase.Interfaces.LockResult = SagaBase.Interfaces.LockResult.LockOk;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
